import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["regionButton", "regionDropdown", "form"];
  static values = {
    mediaId: String,
    mediaType: String,
  };

  connect() {
    // Bind click outside handler
    this.boundHandleClickOutside = this.handleClickOutside.bind(this);

    // Load saved region from localStorage and update UI if needed
    this.loadSavedRegion();
  }

  loadSavedRegion() {
    const savedRegion = localStorage.getItem("justwatch_preferred_region");
    if (savedRegion && this.hasFormTarget) {
      const regionSelector = document.getElementById("region_selector");
      const currentRegion = regionSelector?.value || "US";

      // If saved region differs from current, update the form
      if (savedRegion !== currentRegion && regionSelector) {
        regionSelector.value = savedRegion;
        this.formTarget.requestSubmit();
      }
    }
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleClickOutside);
  }

  toggleRegionDropdown() {
    const dropdown = this.regionDropdownTarget;
    const isHidden = dropdown.classList.contains("hidden");

    if (isHidden) {
      // Show dropdown
      dropdown.classList.remove("hidden");
      // Add click outside listener
      setTimeout(() => {
        document.addEventListener("click", this.boundHandleClickOutside);
      }, 10);
    } else {
      // Hide dropdown
      this.hideDropdown();
    }
  }

  selectRegion(event) {
    const countryCode = event.target.dataset.justwatchOffersCountryParam;
    const regionSelector = document.getElementById("region_selector");

    if (regionSelector && countryCode) {
      // Save to localStorage for future visits
      localStorage.setItem("justwatch_preferred_region", countryCode);

      // Update form and submit
      regionSelector.value = countryCode;
      this.formTarget.requestSubmit();
    }

    this.hideDropdown();
  }

  hideDropdown() {
    this.regionDropdownTarget.classList.add("hidden");
    document.removeEventListener("click", this.boundHandleClickOutside);
  }

  handleClickOutside(event) {
    // Check if click is outside the dropdown and button
    if (!this.element.contains(event.target)) {
      this.hideDropdown();
    }
  }
}
